import { Modal } from "antd";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { evaluationGroupType } from "../API/evaluate";

interface NeedEvaluationProps {
    weekTimeId: number | undefined;
    evaluationId: string | undefined;
    evaluationType: evaluationGroupType | undefined;
}
export default function useNeedEvaluation({
    weekTimeId,
    evaluationType,
    evaluationId
}: NeedEvaluationProps) {
    const history = useHistory();
    const [showModal, SetShowModal] = useState(true);

    function StopRouter() {
        Modal.confirm({
            width: 500,
            title: "评教",
            okButtonProps: { type: "link" },
            cancelButtonProps: { type: "link" },
            okText: "前往评价",
            cancelText: "我知道了",
            content:
                "该课程发起了学评教活动，请同学们力求客观、公正对课程的授课教师进行评价，提交评价后该提醒不会再显示。",
            onOk() {
                if (weekTimeId) {
                    history.push(`/evaluate/${evaluationId}/${evaluationType}`);
                }
            },
            onCancel() {
                SetShowModal(false);
            }
        });
    }

    return { showModal, StopRouter };
}
